import { render, staticRenderFns } from "./CharityRuns.vue?vue&type=template&id=b389880e&scoped=true"
import script from "./CharityRuns.vue?vue&type=script&lang=js"
export * from "./CharityRuns.vue?vue&type=script&lang=js"
import style0 from "./CharityRuns.vue?vue&type=style&index=0&id=b389880e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b389880e",
  null
  
)

export default component.exports